import { Avatar, Modal, ModalContent, ModalOverlay } from "@chakra-ui/react";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../../assets/images/logo.png";
import fire from "../../assets/images/fire.png";
import {
  getPost,
  setEventCommentAction,
} from "../../redux/peoplePost/peoplepost.actions";
import { getPostCommentStatus } from "../../redux/posts/posts.action";
import dayjs from "dayjs";
import CommentCard from "../DashboardHome/CommentCard";
import UserPostShareHome from "./UserPostShare/UserPostShareHome";
import Xclose from "../../assets/images/x-close.svg";
import ReactMapboxGl from "react-mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
/* eslint-disable import/no-webpack-loader-syntax */
import mapboxgl from "mapbox-gl";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.css";
import { getDistanceFromLatLonInKm } from "../../utils/utils";
import Loader from "../Loader";
import { accessToken, apiBaseUrl } from "../../config";
import { RiAlarmWarningLine } from "react-icons/ri";

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass =
  require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

const Map = ReactMapboxGl({
  accessToken: accessToken,
  logoPosition: "bottom-right",
});

function SingleUserPost({
  openReportModal,
  isOpen,
  onClose,
  id,
  theme,
  updateCounts,
  coords,
}) {
  const [message, setMessage] = useState("");
  const [onReply, setOnReply] = useState(false);
  const [replyId, setReplyId] = useState("");
  const [replyMessage, setReplyMessage] = useState("");
  const token = useSelector((state) => state.auth.accessToken);
  const user = useSelector((state) => state.auth.user);
  const singleEventData = useSelector((state) => state.events.peoplePost);
  const fetchPostLoading = useSelector(
    (state) => state.events.fetchPostLoading
  );
  const darktheme = useSelector((state) => state.features.settings.darktheme);
  const dispatch = useDispatch();
  const [editComment, setEditComment] = useState(false);
  const [editMessage, setEditMessage] = useState("");
  const [editCommentId, setEditCommentId] = useState("");
  const [newDoc, setNewDoc] = useState(null);
  const [, setLoadingMore] = useState(false);
  const [currentCount, setCurrentCount] = useState(2);
  const [nestedComment, setNestedComment] = useState([]);
  const [showNestedComment, setShowNestedComment] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Local state for comments to avoid full post refetch
  const [localComments, setLocalComments] = useState([]);
  const [localCommentCount, setLocalCommentCount] = useState(0);

  // Initialize local comments when post data changes
  useEffect(() => {
    if (singleEventData?.comments) {
      setLocalComments(singleEventData.comments);
      setLocalCommentCount(singleEventData.commentCount || 0);
    }
  }, [singleEventData?.comments, singleEventData?.commentCount]);

  // Memoize getSingleEvent to prevent recreation on every render
  const getSingleEvent = useCallback((postId) => {
    dispatch(getPost(postId));
  }, [dispatch]);

  useEffect(() => {
    if (id && isOpen) {
      getSingleEvent(id);
    }
  }, [id, isOpen, getSingleEvent]);

  useEffect(() => {
    if (isOpen) {
      dispatch(getPostCommentStatus());
    }
  }, [isOpen, dispatch]);

  const handlePostComment = async (eventId) => {
    if (message.trim() === "" || isSubmitting) return;

    setIsSubmitting(true);
    try {
      dispatch(setEventCommentAction(message, eventId));

      // Create new comment object locally instead of refetching
      const newComment = {
        commentId: Date.now().toString(),
        text: message,
        username: user?.username,
        userImage: user?.imageUrl,
        userId: user?.user_id,
        displayName: user?.displayName,
        createdAt: new Date().toISOString(),
      };

      // Update local state
      setLocalComments(prev => [newComment, ...prev]);
      setLocalCommentCount(prev => prev + 1);

      // Update parent counts
      if (updateCounts) updateCounts();
      setMessage("");

      setTimeout(() => {
        fetchLatestComments(eventId);
      }, 500);

    } catch (error) {
      console.error("Error posting comment:", error);
      // Revert local state on error
      setLocalComments(prev => prev.slice(1));
      setLocalCommentCount(prev => prev - 1);
    } finally {
      setIsSubmitting(false);
    }
  };

  const fetchLatestComments = async (eventId) => {
    try {
      const { data } = await axios.get(
        `${apiBaseUrl}/events/${eventId}/comments?limit=10`,
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (data?.comments) {
        setLocalComments(data.comments);
        setLocalCommentCount(data.totalCount || data.comments.length);
      }
    } catch (error) {
      console.error("Error fetching latest comments:", error);
    }
  };

  const showReplyBox = (isTrue, id) => {
    setReplyId(id);
    setOnReply(isTrue);
  };

  const handleReplyComment = async (commentId, username, displayName) => {
    if (replyMessage.trim() === "" || isSubmitting) return;

    setIsSubmitting(true);
    try {
      const { data } = await axios.post(
        `${apiBaseUrl}/events/${singleEventData?.eventId}/comment/${commentId}`,
        {
          text: replyMessage,
          replyTo: { username, displayName },
        },
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (data) {
        setLocalComments(prev =>
          prev.map(comment =>
            comment.commentId === commentId
              ? { ...comment, replies: [...(comment.replies || []), data.newReply] }
              : comment
          )
        );

        setReplyMessage("");
        setOnReply(false);
      }
    } catch (err) {
      console.error("Error posting reply:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOpenEditComment = (comment) => {
    setEditComment(true);
    setEditCommentId(comment.commentId);
    setEditMessage(comment.text);
  };

  const handleEditPost = async () => {
    if (editMessage.trim() === "" || isSubmitting) return;

    setIsSubmitting(true);
    try {
      const { data } = await axios.post(
        `${apiBaseUrl}/comment/edit/${editCommentId}`,
        {
          text: editMessage,
        },
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (data) {
        setLocalComments(prev =>
          prev.map(comment =>
            comment.commentId === editCommentId
              ? { ...comment, text: editMessage }
              : comment
          )
        );

        setEditComment(false);
        setEditCommentId("");
        setEditMessage("");
      }
    } catch (err) {
      console.error("Error editing comment:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const close = () => {
    onClose();
    if (updateCounts) updateCounts();
  };

  const allNestedComments = async (commentId) => {
    try {
      setLoadingMore(true);
      const { data } = await axios.get(
        `${apiBaseUrl}/event/${singleEventData?.id}/comment/${commentId}/nestedComment/${newDoc}`,
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setNewDoc(data.lastDoc);
      setNestedComment(prevComments => [...prevComments, ...data.nestedCommentData]);
      let presentCount = currentCount - 10;
      if (presentCount <= 0) {
        setCurrentCount(0);
      } else {
        setCurrentCount(presentCount);
      }
    } catch (err) {
      console.error("Error fetching nested comments:", err);
    } finally {
      setLoadingMore(false);
    }
  };

  const getAllNestedComments = (commentId) => {
    allNestedComments(commentId);
    setShowNestedComment(true);
  };

  if (!isOpen) return null;

  return (
    <Modal
      className="p-0 m-0"
      isOpen={isOpen}
      onClose={close}
      size={"4xl"}
      isCentered
    >
      <ModalOverlay />
      {fetchPostLoading ? (
        <div className="text-center">
          <Loader big={true} />
        </div>
      ) : (
        <ModalContent
          className="p-0 m-0"
          containerProps={{ padding: 0, margin: 0 }}
        >
          {singleEventData && (
            <div className="w-full md:h-[650px] flex rounded-[4px] flex-col sm:flex-row">
              {/* slider */}
              <div className="md:w-[50%] h-full bg-black rounded-l-[4px]">
                <div
                  className="ml-[27px] pt-[14px] h-[10%] cursor-pointer"
                  onClick={close}
                >
                  <div className="bg-[#F9F9FB] flex items-center rounded-[50%] px-[.3rem] w-[27px] h-[27px] text-center">
                    <img className="w-full h-full" src={Xclose} alt="cancel" />
                  </div>
                </div>
                <div className="h-[90%] flex w-full">
                  <div className="h-[50%] md:mt-[15%] w-full">
                    <Carousel
                      autoPlay={false}
                      infiniteLoop={true}
                      showStatus={false}
                      showThumbs={false}
                      centerMode={true}
                      centerSlidePercentage={100}
                      showArrows={true}
                      interval={5000}
                    >
                      {singleEventData?.media?.videos?.length > 0 ? (
                        singleEventData?.media?.videos?.map((item, i) => (
                          <video
                            key={i}
                            loop
                            muted
                            playsInline
                            autoPlay={true}
                            controls
                            className="w-full object-cover rounded-[px] h-[300px] mx-auto"
                          >
                            <source src={item} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        ))
                      ) : singleEventData?.media?.images?.length === 0 ? (
                        <div className="w-full bg-[#272323] h-[50%] mt-2"></div>
                      ) : (
                        singleEventData?.media?.images?.map((item, i) => (
                          <div key={i} className="w-full h-[400px]">
                            <img
                              src={item}
                              className="w-full h-full object-cover"
                              alt="user"
                            />
                          </div>
                        ))
                      )}
                    </Carousel>
                  </div>
                </div>
              </div>
              <div
                className={`md:w-[50%] overflow-y-scroll h-screen md:h-full relative flex flex-col overflow-x-hidden rounded-r-[4px] gap-3 ${theme
                  ? "bg-kdark3 text-white border-[#323232]"
                  : "bg-[#fff] text-[#27272E] border-[#EAECF0]"
                  }`}
              >
                <div className={`h-[85%] overflow-y-scroll mb-3`}>
                  <div className="w-full">
                    <div className={`w-full py-[15px]`}>
                      <div className="px-4">
                        <div className="flex gap-2 sticky top-0 pt-4 z-10  items-center">
                          <Avatar
                            name={singleEventData?.username}
                            src={singleEventData?.userImage}
                            width={"40px"}
                            height={"40px"}
                          />

                          <div className="w-full">
                            <div className="flex items-start justify-between w-full text-[13px]">
                              <div className="flex flex-col items-start">
                                <p className={`${theme ? "text-[#F9FAFB]" : "text-[#27272E]"}   -mb-1 text-sm font-semibold capitalize`}>
                                  {singleEventData?.username}
                                </p>
                                <div className="flex items-center gap-1">
                                  <div className="flex items-center gap-1">
                                    <p className={`${theme ? "text-[#F9FAFB]" : "text-[#667085]"} font-medium text-xs`}>
                                      Arad User
                                    </p>
                                  </div>
                                  <div className="w-[5px] h-[5px] bg-[#868C98] rounded-full ml-1"></div>
                                  <p className={`m-[5px] text-[12px] font-medium flex ${theme ? "text-[#F9FAFB]" : "text-[#667085]"}`}>
                                    {dayjs(
                                      singleEventData?.createdAt
                                    ).fromNow()}
                                  </p>
                                </div>
                              </div>
                              {token && singleEventData?.coords ? (
                                <div className="text-[#FC5C65] bg-[#FC5C651A] rounded-[15px] px-3 py-1 text-[12px] font-semibold ml-[6px]">
                                  {getDistanceFromLatLonInKm(
                                    coords?.latitude,
                                    coords?.longitude,
                                    singleEventData?.coords?.latitude,
                                    singleEventData?.coords?.longitude
                                  )}
                                  km
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className={`mt-[.5rem] cursor-pointer font-semibold ${theme ? "text-white" : "text-[#667085]"} text-sm`}>
                          {singleEventData?.title}
                        </div>
                        <div className={`mt-[.5rem] cursor-pointer font-normal ${theme ? "text-white" : "text-[#667085]"} text-sm`}>
                          {singleEventData?.text}
                        </div>
                        {singleEventData?.category && (
                          <div
                            className={`inline-flex items-center gap-1 px-4 py-2 rounded-full mt-2`}
                            style={{
                              background:
                                singleEventData?.category?.labelBgColor,
                            }}
                          >
                            <RiAlarmWarningLine
                              size={16}
                              style={{
                                background:
                                  singleEventData?.category?.labelBgColor,
                                color: singleEventData?.category?.iconColor,
                              }}
                            />
                            <p
                              className={`text-xs font-bold`}
                              style={{
                                color: singleEventData?.category?.iconColor,
                              }}
                            >
                              {singleEventData?.category?.title}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                    {singleEventData?.coords?.latitude &&
                      singleEventData?.coords?.longitude && (
                        <div className="">
                          <Map
                            renderChildrenInPortal={true}
                            // eslint-disable-next-line react/style-prop-object
                            style="mapbox://styles/mapbox/streets-v8?optimize=true"
                            center={[
                              singleEventData?.coords?.longitude,
                              singleEventData?.coords?.latitude,
                            ]}
                            zoom={[13]}
                            movingMethod="easeTo"
                            containerStyle={{
                              height: "140px",
                              width: "92%",
                              marginLeft: "4%",
                              borderRadius: "5px",
                            }}
                            className="w-full"
                            onStyleLoad={(map) => {
                              const el = document.createElement("div");

                              const markerImage =
                                singleEventData?.category?.title ===
                                  "Safety & Emergencies" ||
                                  singleEventData?.category?.title ===
                                  "Crime & Safety Reports"
                                  ? fire
                                  : Logo;

                              el.className =
                                "w-6 h-6 rounded-full bg-white p-1 flex items-center justify-center border-2 border-red-500";

                              const img = document.createElement("img");
                              img.src = markerImage;
                              img.className =
                                "rounded-full object-contain w-5 h-5";
                              el.appendChild(img);

                              // eslint-disable-next-line
                              new mapboxgl.Marker(el)
                                .setLngLat([
                                  singleEventData?.coords?.longitude,
                                  singleEventData?.coords?.latitude,
                                ])
                                .addTo(map);
                            }}
                          />
                        </div>
                      )}
                  </div>
                  <hr className="border-1 w-[92%] mx-[4%] text-black" />
                  <div className="w-[92%] mx-[4%]">
                    <p className={`${theme ? "text-white" : "text-[#667085]"} text-sm font-medium my-1.5`}>
                      Comments ({localCommentCount})
                    </p>

                    <div className="w-full">
                      {localCommentCount > 0
                        ? localComments.map((data, index) => (
                          <CommentCard
                            key={`${data.commentId}-${index}`}
                            data={data}
                            userData={user}
                            index={index}
                            showNestedComment={showNestedComment}
                            nestedComment={nestedComment}
                            onReply={onReply}
                            replyId={replyId}
                            setReplyMessage={setReplyMessage}
                            handleReplyComment={handleReplyComment}
                            replyMessage={replyMessage}
                            getAllNestedComments={getAllNestedComments}
                            showReplyBox={showReplyBox}
                            setOnReply={setOnReply}
                            handleOpenEditComment={handleOpenEditComment}
                          />
                        ))
                        : null}
                    </div>
                  </div>
                </div>

                {/* single message */}
                <div className={`absolute bottom-0 h-[15%] w-full ${darktheme ? "bg-black" : "bg-white"}`}>
                  <div className="border-t-[0.5px] pt-1 w-full border-[#02023414]">
                    <UserPostShareHome
                      updateCounts={updateCounts}
                      callBacks={getSingleEvent}
                      commentCount={localCommentCount}
                      likeCount={singleEventData?.likeCount}
                      page="single"
                      theme={theme}
                      user={user}
                      openReportModal={openReportModal}
                      selectedPost={singleEventData}
                      handleOpenEditComment={handleOpenEditComment}
                    />
                  </div>

                  {/* message box */}
                  {!editComment ? (
                    <div
                      className={`w-full flex items-center justify-self-end 
                       pl-[13px] ${theme
                          ? "bg-kdark3 text-white border-[#7e7c7c]"
                          : "bg-[#fff] text-[#27272E] border-[#EAECF0]"
                        }`}
                    >
                      {token === "" ? (
                        <div className="w-full h-full flex items-center">
                          <div className="mr-[13px]">
                            <Avatar
                              name={singleEventData?.username}
                              src={singleEventData?.userImage}
                              width={"40px"}
                              height={"40px"}
                            />                          </div>
                          <div className="w-full h-full bg-[#F7F7F7] rounded-[20px]">
                            <input
                              className="border-none outline-none w-full h-full py-2"
                              placeholder="Log in to post a comment"
                              readOnly
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="w-full h-full flex items-center mt-2">
                          <div className="mr-[13px]">
                            <Avatar
                              name={user?.username}
                              src={user?.imageUrl}
                              width={"40px"}
                              height={"40px"}
                            />                                </div>
                          <div className={`w-full h-full ${darktheme ? "" : "bg-[#F7F7F7]"} rounded-[20px] flex`}>
                            <input
                              className="border-2 rounded-l-3xl w-full h-full py-2 px-4 bg-transparent text-white"
                              placeholder="add a comment...."
                              value={message}
                              onChange={(e) => setMessage(e.target.value)}
                              disabled={isSubmitting}
                            />
                            <button
                              className={`${isSubmitting
                                ? "bg-gray-400"
                                : "bg-slate-700 hover:bg-black"
                                } text-white px-4 py-2 rounded-r-3xl transition-colors border-none`}
                              onClick={() =>
                                handlePostComment(singleEventData?.eventId)
                              }
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? "Sending..." : "Send"}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div
                      className={`w-full flex items-center justify-self-end ${token === "" ? "bg-[#FCFCFD]" : "bg-white"
                        } border-[#EAECF0] pl-[13px]`}
                    >
                      {token === "" ? (
                        <div className="w-full h-full flex items-center">
                          <div className="mr-[13px]">
                            <Avatar
                              name={user?.username}
                              src={user?.imageUrl}
                              width={"40px"}
                              height={"40px"}
                            />                          </div>
                          <div className="w-full h-full bg-[#F7F7F7] rounded-[20px]">
                            <input
                              className="border-none bg-transparent text-white outline-none w-full h-full"
                              placeholder="Log in to post a comment"
                              readOnly
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="w-full h-full flex items-center mt-2">
                          <div className="mr-[13px]">
                            <Avatar
                              name={user?.username}
                              src={user?.imageUrl}
                              width={"40px"}
                              height={"40px"}
                            />                                </div>
                          <div className="w-full h-full bg-[#F7F7F7] rounded-[20px] flex">
                            <input
                              className="border-2 rounded-l-3xl w-full h-full py-2 px-4 bg-transparent text-white"
                              value={editMessage}
                              placeholder="Edit Comment...."
                              onChange={(e) => setEditMessage(e.target.value)}
                              disabled={isSubmitting}
                            />
                            <button
                              className={`${isSubmitting
                                ? "bg-gray-400"
                                : "bg-slate-700 hover:bg-black"
                                } text-white px-4 py-2 rounded-r-3xl transition-colors`}
                              onClick={handleEditPost}
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? "Updating..." : "Edit"}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </ModalContent>
      )}
    </Modal>
  );
}

export default SingleUserPost;